import React, { useEffect, useState } from "react";
import api, { formatINR } from "../lib/api";
import { CalendarBlank } from "@phosphor-icons/react";

const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

export default function SalesHistoryTable({ employeeId }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    const params = employeeId ? { employee_id: employeeId } : {};
    api.get("/sales/history", { params })
      .then(({ data }) => setRows(data.months || []))
      .catch(() => setRows([]));
  }, [employeeId]);

  if (rows === null) return null;
  if (rows.length === 0) return null;

  return (
    <div className="bg-white border border-[#E5E7EB]" data-testid="sales-history-table">
      <div className="px-4 sm:px-6 py-4 border-b border-[#E5E7EB]">
        <div className="flex items-center gap-2">
          <CalendarBlank size={16} color="#106109" weight="fill" />
          <div className="label-caps">History</div>
        </div>
        <div className="font-display font-bold text-xl mt-1">Month-wise Target & Achievement</div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-[#F9FAFB] border-b border-[#E5E7EB]">
            <tr>
              {["Month", "Target", "Achieved", "Achievement %", "Failure %"].map((h) => (
                <th key={h} className="px-4 py-3 label-caps text-left">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => {
              const pct = r.achievement_pct;
              const pctColor = pct >= 100 ? "#10B981" : pct >= 50 ? "#FBBF24" : "#DC2626";
              return (
                <tr key={`${r.year}-${r.month}`} className="border-b border-[#F3F4F6]" data-testid={`sh-row-${r.year}-${r.month}`}>
                  <td className="px-4 py-3 font-mono font-semibold">
                    {MONTHS[r.month - 1]} {r.year}
                    {r.override_applied && (
                      <span className="ml-2 text-[10px] px-1.5 py-0.5 bg-[#EFF6FF] text-[#1E40AF] font-semibold">
                        admin edited
                      </span>
                    )}
                  </td>
                  <td className="px-4 py-3 font-mono">{formatINR(r.target)}</td>
                  <td className="px-4 py-3 font-mono">{formatINR(r.achieved)}</td>
                  <td className="px-4 py-3 font-mono font-bold" style={{ color: pctColor }}>
                    {r.target > 0 ? `${r.achievement_pct}%` : "—"}
                  </td>
                  <td className="px-4 py-3 font-mono text-[#DC2626]">
                    {r.target > 0 ? `${r.failure_pct}%` : "—"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
